import { useMemo } from 'react';
import { HubBasePage } from '../../../../../types';
import {
  DiscoveryContentTypes,
  InformaMetaTagPageType,
} from '../../../../../constants';
import { useRootSelector } from '../../../../../store/hooks';
import { selectBrandHubPage } from '../../store/features/page';
import { selectBrandHubOptions } from '../../store/features/options';
import {
  selectHubDiscoveryFacets,
  selectHubDiscoverySiteRecord,
  DiscoverySite,
  HubPageNames,
  SortTypes,
} from '../../../../../store/features/discovery';
import PageLayout from '../../layouts/PageLayout';
import { MetaTags } from '../../../shared/MetaTags';
import { SiteCard } from '../../../shared/productFilter/cards';
import { AggregatedProductPage } from '../../../shared/siteBuilder/AggregatedProductPage';

export function Courses() {
  const {
    data: {
      page: {
        details: { title, description, metaDescription, searchQueryData },
      },
      header: {
        headerNavBar: { brandLogo },
      },
    },
  } = useRootSelector(selectBrandHubPage<HubBasePage>());
  const {
    data: { name: hubName, subBrandName: brandName },
  } = useRootSelector(selectBrandHubOptions);
  const facets = useRootSelector(selectHubDiscoveryFacets);
  const record = useRootSelector((state) =>
    selectHubDiscoverySiteRecord(state, DiscoveryContentTypes.COURSE),
  );

  const heading = title || 'Courses';

  const availableSubBrands = useMemo(() => {
    const { facetsConfig, subBrands: brands = [] } = searchQueryData;

    if (facetsConfig?.subBrandsEnabled) {
      return brands;
    }

    return [brandName];
  }, [brandName, searchQueryData]);

  const defaultValues = useMemo(
    () => ({
      deliveryType: [],
      subBrands: availableSubBrands,
      sectors: [],
      topics: [],
      month: [],
      location: [],
      language: [],
      awardGroup: [],
      informationType: [],
      partners: [],
      creditPartners: [],
      availableSubBrands,
      requestedSortType: SortTypes.FEATURED,
      page: 1,
      count: 20,
      searchInput: '',
      type: [DiscoveryContentTypes.COURSE],
    }),
    [availableSubBrands],
  );

  return (
    <PageLayout>
      <MetaTags
        title={heading}
        titleSuffix={hubName}
        description={metaDescription}
        thumbnail={brandLogo?.path}
        informaPageId={HubPageNames.courses}
        informaPageType={InformaMetaTagPageType.BasePage}
      />
      <AggregatedProductPage<DiscoverySite>
        pageName={HubPageNames.courses}
        contentType={DiscoveryContentTypes.COURSE}
        title={heading}
        subtitle={description}
        facets={facets}
        record={record}
        renderProduct={(product) => <SiteCard data={product} cardType="list" />}
        defaultValues={defaultValues}
        searchQueryData={searchQueryData}
      />
    </PageLayout>
  );
}
